import React from 'react';
import { AdditionalFacilitiesIndicator } from 'components/search/AdditionalFacilitiesIndicator';

const withAdditionalFacilitiesIndicator = (WrappedComponent) => {
	const WithAdditionalFacilitiesIndicator = (props) => {
		const {
			injectedComponents,
			lastInOriginalSearch,
			searchLocation,
			...rest
		} = props;
		let newInjectedComponents = injectedComponents;

		if (lastInOriginalSearch !== null && lastInOriginalSearch >= 0) {
			const additionalPropertiesParams = (
				<AdditionalFacilitiesIndicator location={searchLocation} />
			);
			newInjectedComponents = {
				...injectedComponents,
				[lastInOriginalSearch + 1]: additionalPropertiesParams,
			};
		}

		return (
			<WrappedComponent
				{...rest}
				injectedComponents={newInjectedComponents}
				lastInOriginalSearch={lastInOriginalSearch}
				searchLocation={searchLocation}
			/>
		);
	};

	return WithAdditionalFacilitiesIndicator;
};

export default withAdditionalFacilitiesIndicator;
